<template>
  <nav class="tw-w-full tw-t-0 tw-z-40 tw-bg-white  tw-overflow-hidden ">
    <div
      class="tw-flex tw-justify-between tw-flex-wrap tw-items-center ld-navbar"
    >
      <div class="ld-nav-div tw-flex tw-items-center">
        <RouterLink :to="{ name: 'leave-summary' }" class="ld-logo">
          <img src="../assets/icons/logo.svg" alt="Leavedates logo" />
        </RouterLink>
      </div>
      <div class="tw-block md:tw-hidden">
        <button
          class="tw-flex tw-items-center tw-text-blue-500"
          @click="show = !show"
        >
          <svg
            class="tw-mx-3 tw-my-6 tw-fill-current tw-h-4 tw-w-4"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title>Menu</title>
            <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
          </svg>
        </button>
      </div>

      <div
        :class="[show ? 'tw-block' : 'tw-hidden']"
        class="tw-w-full tw-flex-grow md:tw-flex md:tw-items-center tw-self-center md:tw-w-auto"
      >
        <div
          class="md:tw-flex-grow navbar-items tw-h-full md:tw-mb-0 tw-font-medium"
        >
          <RouterLink
            :to="{ name: 'leave-summary' }"
            class="nav-item-link tw-h-full tw-block md:tw-inline-block tw-no-underline tw-leading-relaxed tw-text-black tw-mt-2 md:tw-mt-0  tw-text-right md:tw-text-left tw-rounded-15/7 "
            data-cy="summary"
          >
            <span>
              Summary
            </span>
          </RouterLink>
          <RouterLink
            :to="wallChartRoute"
            class="nav-item-link tw-h-full tw-block md:tw-inline-block tw-no-underline tw-leading-relaxed tw-text-black tw-mt-2 md:tw-mt-0  tw-text-right md:tw-text-left tw-rounded-15/7"
            data-cy="wall-chart"
          >
            <span>
              Wall Chart
            </span>
          </RouterLink>
          <RouterLink
            id="my-year-link"
            :to="{ name: 'my-year' }"
            class="nav-item-link tw-h-full tw-block md:tw-inline-block tw-no-underline tw-leading-relaxed tw-text-black tw-mt-2 md:tw-mt-0  tw-text-right md:tw-text-left tw-rounded-15/7"
            data-cy="my-year"
          >
            <span>
              My Year
            </span>
          </RouterLink>
          <RouterLink
            v-if="
              activeEmployment &&
                (activeEmployment.is_admin || activeEmployment.is_approver)
            "
            :to="{ name: 'reports-employee' }"
            :class="{ 'router-link-active': subIsActive(reportRoutes) }"
            class="nav-item-link tw-h-full tw-block md:tw-inline-block tw-no-underline tw-leading-relaxed tw-text-black tw-mt-2 md:tw-mt-0  tw-text-right md:tw-text-left tw-rounded-15/7"
            data-cy="reports"
          >
            <span>
              Reports
            </span>
          </RouterLink>
          <a
            v-if="activeCompany"
            id="settings-link"
            :href="`/my-profile?company=${activeCompany.id}`"
            data-cy="settings"
            class="nav-item-link tw-h-full tw-block md:tw-inline-block tw-no-underline tw-leading-relaxed tw-text-black tw-mt-2 md:tw-mt-0  tw-text-right md:tw-text-left tw-rounded-15/7 tw-px-4 tw-py-2 tw-ml-1"
          >
            <span>
              Settings
            </span>
          </a>
        </div>

        <div
          class="tw-flex tw-content-center tw-items-center tw-justify-end md:tw-justify-start tw-flex-wrap tw--ml-5"
        >
          <div v-if="activeCompany" class="tw-font-normal tw-px-3 ">
            <template v-if="canShowCompanySwitcher">
              <CompanySwitcher
                :is-company-saving="isCompanySaving"
                @default-company-changed="updateDefaultCompany"
              />
            </template>
            <template v-else>
              <span
                class="tw-text-gray-800  tw-font-normal tw-truncate"
                style="max-width: 270px; font-size: 1.23rem"
                v-text="activeCompany.name"
              />
            </template>
          </div>
          <div v-else>
            <RouterLink
              :to="{ name: 'companies' }"
              class="tw-block md:tw-inline-block tw-no-underline tw-text-base tw-font-medium tw-text-blue-300 hover:tw-text-gray-800 md:tw-mt-0 md:tw-px-4 tw-py-1 md:tw-py-6"
              data-cy="manage-companies"
            >
              Manage Companies
            </RouterLink>
          </div>
          <div>
            <NewsFeed />
          </div>

          <div class="help-menu-icon">
            <HelpMenu />
          </div>
          <div class="tw-px-4">
            <NotificationMenu />
          </div>
          <div>
            <UserCircle class="tw-ml-5" />
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import routes from '@/router/routes'
import UserCircle from '@/components/nav/UserCircle'
import CompanySwitcher from '@/components/nav/CompanySwitcher'
import NotificationMenu from '@/components/nav/NotificationMenu'
import HelpMenu from '@/components/nav/HelpMenu'
import { mapActions, mapGetters } from 'vuex'
import RequestForm from '@/components/requests/RequestForm'
import NewsFeed from '@/components/nav/NewsFeed'

export default {
  name: 'AppNavbar',

  components: {
    NewsFeed,
    UserCircle,
    NotificationMenu,
    HelpMenu,
    CompanySwitcher,
  },

  data: () => ({
    show: false,
    isCompanySaving: false,
  }),

  computed: {
    ...mapGetters('auth', ['companies']),

    reportRoutes() {
      return routes
        .find(route => route.path === '/reports')
        .children.map(route => '/reports/' + route.path)
    },

    wallChartRoute() {
      let query =
        this.$route.query['group-by'] === 'department'
          ? { 'group-by': 'department' }
          : {}

      return {
        name: 'wall-chart',
        query,
      }
    },

    canShowCompanySwitcher() {
      return (
        this.isActiveEmploymentAnAdmin ||
        (this.companies && this.companies.length > 1)
      )
    },
  },

  methods: {
    ...mapActions('auth', ['fetchUser']),

    subIsActive(input) {
      const paths = Array.isArray(input) ? input : [input]

      return paths.some(path => {
        return this.$route.path.indexOf(path) === 0
      })
    },

    async updateDefaultCompany(companyId = null) {
      try {
        this.isCompanySaving = true

        const method = companyId ? 'post' : 'delete'

        await this.$http[method]('me/default-companies', {
          default_company: companyId,
        })
      } catch (e) {
        this.serverError()
      }

      this.isCompanySaving = false
      this.fetchUser()
    },

    showRequestForm() {
      const form = new RequestForm({
        success: panel => this.$showPanel(panel),
        failed: async message => {
          const confirmed = await this.confirm(message)

          if (!confirmed) return

          window.location.href = `/settings/billing?company=${this.activeCompany.id}`
        },
      })

      form.open(this.activeCompany, this.activeEmployment)
    },
  },
}
</script>
<style scoped>
.nav-item-link {
  border-radius: 6px;
  font-size: 16px;
  padding: 8px 16px;
  margin-left: 4px;
  margin-top: -1px;
}

.ld-logo {
  height: 3.6rem;
}

a img {
  width: 130px;
  height: 40px;
}

.ld-navbar {
  padding: 8px 24px;
}

.ld-nav-div {
  height: 4.9rem;
}

.navbar-items {
  margin-left: 36px;
}

.help-menu-icon {
  margin: -1px 5px 0 1.8rem;
}
</style>
